import { render, staticRenderFns } from "./for-professionals.vue?vue&type=template&id=28c3203c&scoped=true&"
import script from "./for-professionals.vue?vue&type=script&lang=js&"
export * from "./for-professionals.vue?vue&type=script&lang=js&"
import style0 from "./for-professionals.vue?vue&type=style&index=0&id=28c3203c&lang=scss&scoped=true&"
import style1 from "./for-professionals.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3203c",
  null
  
)

export default component.exports